import { AxiosResponse } from 'axios';
import { ProcessingDays } from './ProcessingDays';
import VersionedResource from '../VersionedResource';

export default class ProcessingDaysResource extends VersionedResource {
  public async getAll(fiId: number) : Promise<ProcessingDays> {
    const url = `/api/rcx/config/${fiId}/processing-days`;
    try {
      const response: AxiosResponse = await this.apiClient.get(url);
      return response.data.data;
    } catch (error) {
      // Will 404 if processing days has not been set up yet, so return empty processing days
      if (error.response.status !== 404) {
        throw error;
      } else {
        return {
          normalProcessingDays: [],
          alwaysProcessFirstDayOfMonth: false,
          alwaysProcessLastDayOfMonth: false,
        };
      }
    }
  }

  public async update(fiId: number, data:ProcessingDays):
    Promise<ProcessingDays> {
    const url = `/api/rcx/config/${fiId}/processing-days`;
    const response: AxiosResponse = await this.apiClient.put(url, data);
    return response.data.data;
  }
}
